import React from "react";

export default function Module_1() {
    return (
        <>
            <div className="row g-0 bg-white border rounded overflow-hidden flex-md-row my-4 shadow-sm h-md-250 position-relative">
                <div className="col-md-8 order-1 order-md-last p-4 d-flex flex-column position-static">
                    <p className="card-text mb-auto lead">
                        Founded in 2016, DSSL is a fast-growing US-based
                        lighting manufacturer providing high performance indoor
                        and outdoor systems, as well as retrofit kits, to
                        specifiers, lighting professionals and end-users. DSSL
                        is especially well-known for its customizing
                        capabilities, one of the driving forces behind its
                        growth. In 2021, DSSL expanded its offering with
                        innovative designs and unique products to meet an
                        increasing demand for specification grade lighting.
                    </p>
                </div>
                <div className="col-md-4">
                    <div className="bg-dark d-flex justify-content-center align-items-center p-4 h-100">
                        <h1 className="text-light fst-italic mb-0">
                            The Back Story
                        </h1>
                    </div>
                </div>
            </div>
        </>
    );
}
